import React, { useEffect, useState } from 'react'
import System from 'src/helper/system';
import { useCartStore } from 'src/hooks/cart';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import { useOrderStore } from 'src/hooks/order';
import { profileStore } from 'src/hooks/profile';
import useReduxState from 'src/hooks/useReduxState';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Constants from 'src/helper/Constants';
import Helper from 'src/helper/Helper';
import { __set, __remove } from "src/store/axios_indicator";
import { Beacon } from 'src/component/Global/Beacon';
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';
import RoleAndPermission from 'src/helper/RoleAndPermission';

const CheckoutShipping = () => {
    const [__check] = useAxiosIndicatorCheck();
    const { translation: t } = System;
    const {
        siteUser: { CORE, WEB },
        addressType,
        mobilePattern,
        registerEmailPattern,
        attnAsiaPattern,
        attnJapanPattern,
        paymentError,
        INVALIDMANUFACTURER,
        Restricted_Countries,
        phoneNumberPattern,
        PreferenceType: { Default_ShipTo },
        speedBoats: { apacAbbr, japanAbbr },
        checkOutSteps: { ADDRESS_STEP, METHOD_STEP },
        checkoutApiSteps: { Step1 },
        salesOrgHK1E } = Constants
    const { storageName: { PAYMENT_ERROR }, avUserInfoData: { currentUser, salesOrg, accountNumber, speedBoatAbbr } } = System

    const [addShippingAddress, setAddShippingAddress] = useState(true);
    const [isEdit, setIsEdit] = useState(false);
    const [errors, setErrors] = useState({});
    const [isErrorInStep1, setIsErrorInStep1] = useState(false);
    const [initialOrderFetch, setInitialOrderFetch] = useState(true)

    const [{ shipping_addresses, credit_line_user }, { get_profile_account_information, fetch_all_carrier_data }, { set_account_address_default }] = profileStore();
    const [{ }, { system_alert_indicator, remove_system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const [{ WEB_ORDER_ID, CART_PRODUCTS, CART_DATA }, { }, { }] = useCartStore();
    const [{ validate_order_from_server }, { get_validate_order_from_server, fetch_place_order_items }, { place_your_order }] = useOrderStore();

    const [checkoutInfo, setCheckoutInfo] = useReduxState({}, 'setCheckoutInfo')
    const shippingAddressInfo = checkoutInfo?.shippingAddressInfo || {}
    const [shippingAddress, setShippingAddress] = useState({})
    const [, setCheckoutStepStatus] = useReduxState(ADDRESS_STEP, 'setCheckoutStepStatus')
    const [, setExportComplianceStatus] = useReduxState(false, 'setExportComplianceStatus')
    const [, setComplianceValue] = useReduxState('', 'setComplianceValue')
    const [prevShippingData, setPrevShippingData] = useReduxState('', 'setPrevShippingData')
    const [shippingAddressList, setShippingAddressList] = useState([])
    const [newShipTo, setNewShipTo] = useReduxState('', "setNewShipTo");
    const isCoreUser = currentUser === CORE
    const isContainSoftwareParts = System.getCurrentRegionWithType(japanAbbr) && CART_PRODUCTS && Object.values(CART_PRODUCTS).some(f => f.SoftwareDownloadFlag === true);
    const isRequestShippingPermission = RoleAndPermission.checkActivePermission(RoleAndPermission.profilePermission.submit_req_for_address)
    const isAddEditAddressPermission = RoleAndPermission.checkActivePermission(RoleAndPermission.profilePermission.add_edit_address)
    const isOnlySoftwareParts = System.getCurrentRegionWithType(japanAbbr) && CART_PRODUCTS && !Object.values(CART_PRODUCTS).some(f => f.SoftwareDownloadFlag === false);
    const attnPattern = System.getCurrentRegionWithType(japanAbbr) ? attnJapanPattern : attnAsiaPattern

    const tempAddressObject = element => {
        const tempSelectedAddress = {
            address: {
                countryCode: element?.country,
                addressLineOne: element?.address1,
                addressLineTwo: element?.address2,
                cityName: element?.city,
                stateName: element?.stateName,
                postalCode: element?.zip,
                countryName: element?.countryName
            },
            companyName: element?.companyName,
            default: null,
            firstName: element?.companyName,
            id: element?.provisionalId,
            lastName: '',
            isProvisional: true,
            provisionalId: element?.provisionalId,
            isSelected: element?.isSelected
        }

        return tempSelectedAddress
    }

    // Set default shipping address
    useEffect(() => {
        async function fetchHere() {
            const params = {
                OrderId: WEB_ORDER_ID,
                IsOrderPlaced: false
            }
            const detail = await fetch_place_order_items(params);
            if (detail && Object.entries(detail.payload).length > 0) {

                const ele = detail?.payload?.provisionalShippingAddress?.find((ele) => ele.isSelected)

                const address = ele !== undefined ? tempAddressObject(ele) : { ...shipping_addresses.find((shipAdd) => shipAdd.id === detail.payload?.shipToId ? shipAdd.id : shipping_addresses?.length === 1 ? shipping_addresses[0] : null) }

                let shippingAddressData = {
                    attn: detail.payload.attn,
                    telephoneNumber: detail.payload.telephoneNumber,
                    SoftwareDownloadEmail: detail.payload.softwareDownloadEmail || '',
                    shippingPreference: detail.payload.shippingPreference,
                    ...address
                }

                setShippingAddress(shippingAddressData)
                setInitialOrderFetch(false)
            }

            sessionStorage.removeItem('provisionalShippingAddress')
            let tempAddress = []
            if (detail?.payload?.provisionalShippingAddress?.length > 0 && System.getCurrentRegionWithType(apacAbbr, CORE)) {
                tempAddress = detail.payload?.provisionalShippingAddress.map(ele => {
                    return tempAddressObject(ele)
                })
                sessionStorage.setItem('provisionalShippingAddress', JSON.stringify(tempAddress))
            }
            setShippingAddressList([...shipping_addresses, ...tempAddress])
        }

        const tempAdd = JSON.parse(sessionStorage.getItem('provisionalShippingAddress')) || []
        if ((!shippingAddressInfo?.id || initialOrderFetch) && shipping_addresses?.length > 0 && !__check(['VIEW_CART_API_CALL']).status) {
            if (WEB_ORDER_ID) {
                fetchHere();
            } else {
                const address = shipping_addresses?.length === 1 ? shipping_addresses[0] : shipping_addresses?.find(ele => ele.default)
                setShippingAddress(address)
                setShippingAddressList([...shipping_addresses, ...tempAdd])
            }
        }

        if (!initialOrderFetch) {
            if (WEB_ORDER_ID && System.getCurrentRegionWithType(apacAbbr, CORE) && tempAdd) {
                setShippingAddressList([...shipping_addresses, ...tempAdd]);
            } else {
                setShippingAddressList(shipping_addresses)
            }
        }

    }, [WEB_ORDER_ID, __check(['VIEW_CART_API_CALL']).status, shipping_addresses]);

    useEffect(() => {
        sessionStorage.removeItem('provisionalShippingAddress')
    }, [])

    useEffect(() => {
        if (shippingAddress) {
            setCheckoutInfo({ ...checkoutInfo, shippingAddressInfo: { ...checkoutInfo?.shippingAddressInfo, ...shippingAddress } })
        }
    }, [shippingAddress])

    useEffect(() => {
        if (Object.keys(newShipTo)?.length > 0) {
            setShippingAddressList([...shippingAddressList, newShipTo])
        }
    }, [newShipTo])

    // Validate order api call
    useEffect(() => {
        const fetchHere = async () => {
            __set('VALIDATE_ORDER_API_CALL');
            const tempAdd = {
                "companyName": shippingAddressInfo.companyName,
                "addressLineOne": shippingAddressInfo.address.addressLineOne,
                "addressLineTwo": shippingAddressInfo.address.addressLineTwo,
                "cityName": shippingAddressInfo.address.cityName,
                "stateCode": shippingAddressInfo.address.stateName,
                "countryCode": shippingAddressInfo.address.countryCode,
                "countryName": shippingAddressInfo.address.countryName,
                "postalCode": shippingAddressInfo.address.postalCode
            }
            await get_validate_order_from_server({ shipToAddressId: shippingAddressInfo.id, provisionalAddress: System.getCurrentRegionWithType(apacAbbr, CORE) && tempAdd })
            __remove('VALIDATE_ORDER_API_CALL');
        }
        if (shippingAddressInfo?.id) {
            fetchHere()
        }
    }, [shippingAddressInfo?.id])

    // Set payment error on load
    useEffect(() => {
        if (new URL(window.location.href)?.searchParams.has(paymentError)) {
            system_alert_indicator({
                name: 'placeOrderError',
                message: localStorage.getItem(PAYMENT_ERROR),
                type: "danger",
                isDisplay: false,
                isDisplayIcon: true
            })
        } else {
            localStorage.removeItem(PAYMENT_ERROR)
        }
        async function fetchHere() {
            await get_profile_account_information();
        }
        fetchHere()
    }, [])

    // Validate shipping address api call
    const validateShippingAddress = async () => {
        let validationErrors = {};
        await remove_system_alert_indicator(INVALIDMANUFACTURER);

        if (validate_order_from_server && Object.keys(validate_order_from_server).length > 0) {
            Object.entries(validate_order_from_server.validation || {}).forEach(([name, message]) => {
                system_alert_indicator({
                    name,
                    message,
                    type: "danger",
                    isDisplay: false,
                    isDisplayIcon: true,
                });

                validationErrors[name] = message;
            });
        }

        return Object.keys(validationErrors).length === 0;
    }

    //  Change shipping address
    const changeShipAddress = (address) => {
        setCheckoutInfo({
            ...checkoutInfo,
            shippingMethodInfo: {},
            shippingAddressInfo: {
                ...address,
                attn: shippingAddressInfo.attn?.trim(),
                telephoneNumber: shippingAddressInfo.telephoneNumber?.trim(),
                SoftwareDownloadEmail: shippingAddressInfo.SoftwareDownloadEmail?.trim() || null
            }
        })

        if (System.getCurrentRegionWithType(apacAbbr, CORE)) {
            const tempAdd = JSON.parse(sessionStorage.getItem('provisionalShippingAddress'))
            const updatedTempAddress = tempAdd && tempAdd?.map(ele => {
                ele = {
                    ...ele,
                    isSelected: ele.id === address.id ? true : false
                }
                return ele
            })
            sessionStorage.setItem('provisionalShippingAddress', JSON.stringify(updatedTempAddress))
        }
        setIsErrorInStep1(false)
        setExportComplianceStatus(false)
        setComplianceValue("")
    };

    // Validate data for attn and phone number
    const onValidateData = () => {
        let validationModal = {};

        if ((System.getCurrentRegionWithType(apacAbbr) || isContainSoftwareParts || (System.getCurrentRegionWithType(japanAbbr) && !credit_line_user))) {
            if (!(shippingAddressInfo.attn)?.trim() || ((shippingAddressInfo.attn)?.trim() && !attnPattern.test(shippingAddressInfo.attn))) {
                validationModal.attn = t('validNameNoSpecialChars');
            }
            if (!shippingAddressInfo.telephoneNumber?.trim() || (shippingAddressInfo.telephoneNumber?.trim() && !phoneNumberPattern.test(shippingAddressInfo.telephoneNumber?.trim()))) {
                validationModal.telephoneNumber = t('validPhoneNumberIsRequired') + '.';
            }
        } else {
            if ((shippingAddressInfo.attn)?.trim() && ((shippingAddressInfo.attn)?.trim() && !attnPattern.test(shippingAddressInfo.attn))) {
                validationModal.attn = t('validNameNoSpecialChars');
            }
            if (shippingAddressInfo.telephoneNumber && (shippingAddressInfo.telephoneNumber && !phoneNumberPattern.test(shippingAddressInfo.telephoneNumber))) {
                validationModal.telephoneNumber = t('validPhoneNumberIsRequired') + '.';
            }
        }

        if (System.getCurrentRegionWithType(japanAbbr) && isContainSoftwareParts) {
            if (!registerEmailPattern.test(shippingAddressInfo.SoftwareDownloadEmail)) {
                validationModal.SoftwareDownloadEmail = t('aValidEmailAddressIsRequired');
            }
        }

        setErrors(validationModal);
        return Object.keys(validationModal).length === 0;
    };

    const onSubmit = async () => {
        let isValidShippingAddress = await validateShippingAddress();

        if (isValidShippingAddress == false) {
            setIsErrorInStep1(true);
        } else {
            setIsErrorInStep1(false);
        }

        let isValid = await onValidateData();

        if (isValid && isValidShippingAddress) {
            setCheckoutInfo({ ...checkoutInfo, shippingAddressInfo: { ...shippingAddressInfo, attn: shippingAddressInfo.attn?.trim(), telephoneNumber: shippingAddressInfo.telephoneNumber?.trim(), SoftwareDownloadEmail: shippingAddressInfo.SoftwareDownloadEmail?.trim() || null } })
            setAddShippingAddress(false)

            if (initialOrderFetch) {
                setInitialOrderFetch(false)
            }
            if (prevShippingData !== shippingAddressInfo?.id) {
                setExportComplianceStatus(false)
                setComplianceValue("")
            }

            const tempAddresssess = JSON.parse(sessionStorage.getItem('provisionalShippingAddress')) || []
            let tempPayload = tempAddresssess && tempAddresssess?.map(ele => {
                ele = {
                    provisionalId: ele.provisionalId ? ele.provisionalId : null,
                    companyName: ele.companyName,
                    address1: ele.address.addressLineOne,
                    address2: ele.address.addressLineTwo,
                    city: ele.address.cityName,
                    country: ele.address.countryCode,
                    state: ele.address.stateCode || ele.address.stateName,
                    zip: ele.address.postalCode,
                    isSelected: ele?.isSelected || false,
                    addressType: "ShipTo"
                }
                return ele
            })

            let params = {
                shipToId: JSON.parse(sessionStorage.getItem('provisionalShippingAddress'))?.some(ele => ele?.isSelected === true) ? null : shippingAddressInfo.id,
                attn: shippingAddressInfo.attn?.trim() ? shippingAddressInfo.attn?.trim() : '',
                telephoneNumber: shippingAddressInfo.telephoneNumber?.trim() ? shippingAddressInfo.telephoneNumber?.trim() : '',
                SoftwareDownloadEmail: System.getCurrentRegionWithType(japanAbbr) ? (shippingAddressInfo.SoftwareDownloadEmail?.trim() ? shippingAddressInfo.SoftwareDownloadEmail?.trim() : null) : null,
                speedboat: speedBoatAbbr,
                isOrderPlaced: false,
                orderStep: Step1,
                isOrderBlock: false,
                provisionalShippingAddress: System.getCurrentRegionWithType(apacAbbr, CORE) ? tempPayload : [],
                IsSoftwareDownloadbleOnly: System.getCurrentRegionWithType(japanAbbr) ? isContainSoftwareParts : null
            }

            setPrevShippingData(shippingAddressInfo?.id)

            __set("PLACE_ORDER_API_CALL");
            let res = await place_your_order(params)
            __remove("PLACE_ORDER_API_CALL");

            if (res?.webOrderNumber) {
                setIsEdit(true);
                //fetch carrier options
                if ((System.getCurrentRegionWithType(japanAbbr) && !credit_line_user && !isOnlySoftwareParts) || System.getCurrentRegionWithType(apacAbbr, WEB) || (System.getCurrentRegionWithType(apacAbbr, CORE) && salesOrg === salesOrgHK1E)) {
                    const params = {
                        orderId: res?.webOrderNumber,
                        country: shippingAddressInfo?.address?.countryName?.trim(),
                        countryCode: shippingAddressInfo?.address?.countryCode?.trim(),
                        shipToId: shippingAddressInfo?.id,
                        speedboat: speedBoatAbbr
                    }
                    __set('CARRIER_OPTION_UPDATE');
                    await fetch_all_carrier_data({
                        params: params,
                        isOnlyAvnet: System.getCurrentRegionWithType(japanAbbr) ? true : false,
                        isOnlyManual: System.getCurrentRegionWithType(apacAbbr, CORE) && salesOrg === salesOrgHK1E ? true : false
                    });
                    __remove('CARRIER_OPTION_UPDATE');
                }
                setCheckoutStepStatus(METHOD_STEP)
                checkoutEvent();
            } else {
                system_alert_indicator({
                    name: 'placeOrderError',
                    message: res?.Message || t('orderSubmissionFailedPleaseTryAgainLater'),
                    type: "danger",
                    isDisplay: false,
                    isDisplayIcon: true
                })
            }
        }
    }

    //  Set default address
    const setDefaultAddress = async (address, preferenceFilter = "") => {
        const data = {
            preferenceType: Default_ShipTo,
            preferenceValue: address?.id,
            preferenceFilter: preferenceFilter
        }
        __set('SET_DEFAULT_SHIPPING_ADDRESS_API_CALL');
        const res = await set_account_address_default(data);

        if (res) {
            await get_profile_account_information();
            changeShipAddress(address)
        }
        __remove('SET_DEFAULT_SHIPPING_ADDRESS_API_CALL');
    }

    const openAddShippingPopup = (addressInfo) => {
        System.popup('ProfileAddressPopup', { ...addressInfo, isFrom: Constants.systemModules.CHECKOUT });
    }

    const checkoutEvent = () => {
        if (Object.keys(CART_DATA)?.length > 0 && Object.keys(CART_PRODUCTS)?.length > 0) {
            let cartProductArr = Object.keys(CART_DATA).map((x) => {
                return { ...CART_DATA[x], ERPSupplierCode: CART_PRODUCTS[x]?.ERPSupplierCode, qas: CART_DATA[x]?.quantity }
            });
            if (cartProductArr.length > 0) {
                HelperAnalyticsEvent.cartEvent({ productList: cartProductArr, eventName: 'checkoutStep1' })
            }
        }
    }
    return (
        <div className={`shipping-address steps-inner mb-3 active ${isEdit ? ' completed' : ''}`}>
            <div className="checkout-titles d-flex justify-content-between"><h2>1. {t('shippingAddress')} </h2> {isEdit && <a className='text-white' onClick={() => {
                setIsEdit(false);
                remove_system_alert_indicator('carrierOptionAlert');
                setCheckoutStepStatus(ADDRESS_STEP)
                setAddShippingAddress(false)
            }} >{t('change')} </a>}</div>

            <div className='shipping-address-detail checkbox-steps-content pt-0'>
                <div className='bs5 row'>
                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pt-2'>
                        <div style={!addShippingAddress ? { display: "block" } : { display: "none" }}>

                            <div className='d-flex justify-content-between'>
                                {shippingAddressInfo?.address && <div>
                                    <div className="font-16 font-bold font-apecru mb-2">{shippingAddressInfo?.companyName} </div>
                                    <p> {shippingAddressInfo?.address?.addressLineOne},<br /> {Helper.valueIsNotNull(shippingAddressInfo?.address?.addressLineTwo) ? <>{shippingAddressInfo?.address?.addressLineTwo + ","}<br /></> : ""}{shippingAddressInfo?.address?.cityName}, {Helper.valueIsNotNull(shippingAddressInfo?.address?.stateName) ? shippingAddressInfo?.address?.stateName + " " : ""} {shippingAddressInfo?.address?.postalCode}, <br /> {shippingAddressInfo?.address?.countryName}.</p>
                                </div>}
                                {isCoreUser && !shippingAddressInfo?.isProvisional && <span className='text-start'><b>{t('shippingAccountNo')}.</b><p>{shippingAddressInfo?.id}</p> </span>}
                            </div>
                            {!isCoreUser && !isEdit && <div className="shipping-option step-complete-hide position-relative" onClick={() => !isEdit ? setAddShippingAddress(true) : ''} >
                                <Beacon position={"right"} content={() => "Click here to add a new address or to edit/delete default address."}
                                    opener={() => (
                                        <div className="becon-dot"></div>
                                    )} />
                                <a className="text-blue2 me-1">{t('addChangeShippingAddress')}</a>
                            </div>}
                            {isCoreUser && !isEdit && <div className="shipping-option step-complete-hide position-relative" onClick={() => !isEdit ? setAddShippingAddress(true) : ''} >
                                <a className='addnewaddress text-uppercase'>
                                    <i className="fa fa-plus me-2" aria-hidden="true"></i>{t('changeRequestANewAddress')}
                                </a>
                            </div>}
                        </div>
                        <div className='choose-address' style={addShippingAddress ? { display: "block" } : { display: "none" }}>
                            <div className='font-arial font-16 '><b>{t('chooseAddress')}:</b></div>
                            {System.getCurrentRegionWithType(apacAbbr, CORE) && isRequestShippingPermission && (
                                <a onClick={() => { if (!JSON.parse(sessionStorage.getItem('provisionalShippingAddress')) && System.getCurrentRegionWithType(apacAbbr, CORE)) openAddShippingPopup({ 'type': addressType.SHIP_TO, 'addressInfo': {} }) }} className={`addnewaddress ${JSON.parse(sessionStorage.getItem('provisionalShippingAddress')) && 'text-black-sand'}`}> <i className="fa fa-plus me-2" aria-hidden="true"></i>
                                    {t('requestANewAddress')}
                                </a>
                            )}
                            {!isCoreUser && isAddEditAddressPermission && (
                                <a onClick={() => openAddShippingPopup({ 'type': addressType.SHIP_TO, 'addressInfo': {} })} className='addnewaddress text-uppercase'> <i className="fa fa-plus me-2" aria-hidden="true"></i>
                                    {t('addANewAddress')}
                                </a>
                            )}

                            <div className='choose-address-list'>
                                {shippingAddressList?.length > 0 && <div>
                                    <div className='font-arial font-13 mb-2'><b> <u>{t('address')}</u></b></div>

                                    {shippingAddressList.map((shipadd, index) => (<div key={index} className='choose-address-box'>
                                        <input
                                            className="form-check-input"
                                            type="radio" name="radioNoLabel"
                                            id={`radioNoLabel${index}`}
                                            checked={shippingAddressInfo.id === shipadd.id || (shippingAddressList?.length === 1 && true)}
                                            value="" aria-label="..."
                                            disabled={Restricted_Countries.includes(shipadd?.address?.countryCode)}
                                            onChange={() => changeShipAddress(shipadd)} />

                                        <div className='font-arial font-13'>
                                            <label htmlFor={`radioNoLabel${index}`} className="cursor-pointer">
                                                <strong>{shipadd?.companyName}</strong>
                                                <p className='font-arial font-13'>
                                                    {shipadd?.address?.addressLineOne},<br /> {Helper.valueIsNotNull(shipadd?.address?.addressLineTwo) ? <> {shipadd?.address?.addressLineTwo + ","}<br /></> : ""} {shipadd?.address.cityName}, {Helper.valueIsNotNull(shipadd?.address.stateName) ? shipadd?.address.stateName + " " : ""} {shipadd?.address.postalCode}, <br /> {shipadd?.address.countryName}.
                                                </p>
                                            </label>
                                            <p className='font-arial font-12 pb-2'>
                                                {(shipadd.isProvisional !== true) && (shipadd?.default ?
                                                    <strong> {t('default')}</strong> :
                                                    <a onClick={async () => setDefaultAddress(shipadd, (isCoreUser ? (salesOrg + "-" + accountNumber) : ""))}>{t('setToDefault')}</a>)}
                                            </p>
                                        </div>
                                    </div>))}
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                        <div className='shipping-additional-info step-complete-hide info-text'>
                            <div className='form'>
                                <div className='mb-2'>{t('informationUsedForOrderOrShippingIssues')}</div>
                                <div className="mb-3">
                                    <label htmlFor="attn" className="form-label">{t('attn')} {(System.getCurrentRegionWithType(apacAbbr) || isContainSoftwareParts || (System.getCurrentRegionWithType(japanAbbr) && !credit_line_user)) && "*"} {System.getCurrentRegionWithType(japanAbbr) && t('attnJapanText')}</label>
                                    <input
                                        type="text"
                                        disabled={isEdit}
                                        className="form-control"
                                        id="attn"
                                        maxLength={35}
                                        placeholder='Attention'
                                        value={shippingAddressInfo.attn}
                                        onChange={({ target: { value } }) => setCheckoutInfo({ ...checkoutInfo, shippingAddressInfo: { ...checkoutInfo.shippingAddressInfo, attn: value } })}
                                    />
                                    {errors.attn && <p className="error">{errors.attn}</p>}
                                </div>
                                <div className="mb-3"><label htmlFor="ph-no" className="form-label">{t('phoneNumber')} {(System.getCurrentRegionWithType(apacAbbr) || isContainSoftwareParts || (System.getCurrentRegionWithType(japanAbbr) && !credit_line_user)) && "*"}</label>
                                    <input
                                        type="text"
                                        disabled={isEdit}
                                        className="form-control"
                                        id="phone"
                                        placeholder={t('phoneNumber')}
                                        value={shippingAddressInfo.telephoneNumber}
                                        onChange={({ target: { value } }) => setCheckoutInfo({ ...checkoutInfo, shippingAddressInfo: { ...checkoutInfo.shippingAddressInfo, telephoneNumber: value } })}
                                        maxLength={25}
                                    />
                                    {errors.telephoneNumber && <p className="error">{errors.telephoneNumber}</p>}
                                </div>

                                {isContainSoftwareParts && System.getCurrentRegionWithType(japanAbbr) && <div className="mb-3"><label htmlFor="email" className="form-label">{t('emailAddressForDownloadableProducts')}*</label>
                                    <input
                                        type="text"
                                        disabled={isEdit}
                                        className="form-control"
                                        id="email"
                                        maxLength={70}
                                        placeholder={t('emailAddressForDownloadableProducts')}
                                        value={shippingAddressInfo.SoftwareDownloadEmail}
                                        onChange={({ target: { value } }) => setCheckoutInfo({ ...checkoutInfo, shippingAddressInfo: { ...checkoutInfo.shippingAddressInfo, SoftwareDownloadEmail: value } })}
                                    />
                                    {errors.SoftwareDownloadEmail && <p className="error">{errors.SoftwareDownloadEmail}</p>}</div>}
                            </div>
                        </div>

                        {(shippingAddressInfo?.attn || shippingAddressInfo?.telephoneNumber || shippingAddressInfo?.SoftwareDownloadEmail) && <div className="step-complete-show">
                            <div className="info-text">
                                {shippingAddressInfo?.attn && <p className="mb-2">ATTN: {shippingAddressInfo?.attn}</p>}
                                {shippingAddressInfo?.telephoneNumber && <p className="mb-2">{t('phoneNumber')}: {shippingAddressInfo?.telephoneNumber}</p>}
                                {shippingAddressInfo?.SoftwareDownloadEmail && <p className="mb-2">{t('emailAddressForDownloadableProducts')}: <span className="text-wrap text-break">{shippingAddressInfo?.SoftwareDownloadEmail}</span></p>}
                            </div>
                        </div>}
                    </div>
                </div>
                <hr className="mb-0 mt-0 step-complete-hide"></hr>
            </div>
            <div className='shipping-method-detail checkbox-steps-content pt-0 step-complete-hide'>
                <div className='bs5 row'>
                    <div className='col-12 col-sm-12 col-lg-6 col-xl-6'>

                    </div>

                    <div className='col-12 col-sm-12 col-lg-6 col-xl-6 d-flex align-items-start flex-wrap'>
                        {!isEdit &&
                            <button
                                type="button"
                                className="bs5 btn btn-primary btn-sm mt-auto d-block ms-auto w100"
                                disabled={(!shippingAddressInfo?.id || isErrorInStep1 == true || Restricted_Countries.includes(shippingAddressInfo?.address?.countryCode)) && shippingAddressList?.length !== 1}
                                onClick={() => onSubmit()} form="hook-form">{t('continue')}
                            </button>}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CheckoutShipping;